// FUNCTION TO HIT HAPTIC FEEDBACK ON MOBILE DEVICE
// time in ms B DEFAULT 40
const hitHapticFeedback = (time = 40) => {
  window.navigator.vibrate && window.navigator.vibrate(time);
};

export default hitHapticFeedback;
